module.exports = __webpack_public_path__ + "static/media/W00F0004.b77e39c3.svg";